import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Find Operator used in Find Conditions.
 */
export var FindOperator = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function FindOperator(type, value) {
    var useParameter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var multipleParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var getSql = arguments.length > 4 ? arguments[4] : undefined;
    var objectLiteralParameters = arguments.length > 5 ? arguments[5] : undefined;
    _classCallCheck(this, FindOperator);
    this["@instanceof"] = Symbol.for("FindOperator");
    this._type = type;
    this._value = value;
    this._useParameter = useParameter;
    this._multipleParameters = multipleParameters;
    this._getSql = getSql;
    this._objectLiteralParameters = objectLiteralParameters;
  }
  // -------------------------------------------------------------------------
  // Accessors
  // -------------------------------------------------------------------------
  /**
   * Indicates if parameter is used or not for this operator.
   * Extracts final value if value is another find operator.
   */
  _createClass(FindOperator, [{
    key: "useParameter",
    get: function get() {
      if (InstanceChecker.isFindOperator(this._value)) return this._value.useParameter;
      return this._useParameter;
    }
    /**
     * Indicates if multiple parameters must be used for this operator.
     * Extracts final value if value is another find operator.
     */
  }, {
    key: "multipleParameters",
    get: function get() {
      if (InstanceChecker.isFindOperator(this._value)) return this._value.multipleParameters;
      return this._multipleParameters;
    }
    /**
     * Gets the Type of this FindOperator
     */
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
    /**
     * Gets the final value needs to be used as parameter value.
     */
  }, {
    key: "value",
    get: function get() {
      if (InstanceChecker.isFindOperator(this._value)) return this._value.value;
      return this._value;
    }
    /**
     * Gets ObjectLiteral parameters.
     */
  }, {
    key: "objectLiteralParameters",
    get: function get() {
      if (InstanceChecker.isFindOperator(this._value)) return this._value.objectLiteralParameters;
      return this._objectLiteralParameters;
    }
    /**
     * Gets the child FindOperator if it exists
     */
  }, {
    key: "child",
    get: function get() {
      if (InstanceChecker.isFindOperator(this._value)) return this._value;
      return undefined;
    }
    /**
     * Gets the SQL generator
     */
  }, {
    key: "getSql",
    get: function get() {
      if (InstanceChecker.isFindOperator(this._value)) return this._value.getSql;
      return this._getSql;
    }
  }]);
  return FindOperator;
}();